import { useFormField } from "@faire/deprecated-retailer-visitor-shared/components/SignUpForm/FormField";

const EVENT_NAME = "store-opening-date";
const EVENT_PREFIX = "sign-up-page/modal";

const validator = () => false as const;

// Started this state here, but if there are no other usages I'll put it back
// inside useAppSignUpState.
export const useStoreOpeningDateState = () => {
  const storeOpeningDate = useFormField<number | undefined>(
    undefined,
    EVENT_NAME,
    validator,
    EVENT_PREFIX
  );

  return {
    storeOpeningDate,
  };
};
